export const formatMemoryAdd = (input: string, memory: string[]): string => {
  const newValue = parseFloat(input);
  const last = memory[memory.length - 1];
  const lastResult = parseFloat(last.split("=")[1].trim());
  const newResult = lastResult + newValue;
  return `${last.split("=")[0]} + ${newValue} = ${newResult}`;
};

export const formatMemorySubtract = (input: string, memory: string[]): string => {
  const newValue = parseFloat(input);
  const last = memory[memory.length - 1];
  const lastResult = parseFloat(last.split("=")[1].trim());
  const newResult = lastResult - newValue;
  return `${last.split("=")[0]} - ${newValue} = ${newResult}`;
};
